/* eslint-disable radix */
import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useLazyQuery } from '@apollo/client';
import { SEND_EMAIL_TO_MULTIPLE } from 'pages/Vendor/VendorGraphQL';
import { toast } from 'react-toastify';
import ErrorBoundary from 'components/common/ErrorBoundary';
import SendEmailForm from './components/SendEmailForm';

export const emailValidationSchema = Yup.object({
  subject: Yup.string('Enter the Subject')
    .max(500, 'Subject should be less than 500 characters')
    .required('Subject is required')
    .trim(),

  emailBody: Yup.string('Enter the Email Body')
    .max(2000, 'Body should be less than 2000 characters')
    .required('Email Body is required')
    .trim(),
});

const SendEmail = ({ drawerToggle, rowSelection, resetRowSelection }) => {
  const [sendEmailToMultipleTraders] = useLazyQuery(SEND_EMAIL_TO_MULTIPLE);

  const handleSubmit = async (values) => {
    try {
      const val = await sendEmailToMultipleTraders({
        variables: {
          traderIds: rowSelection?.map((key) => parseInt(key)),
          subject: values?.subject,
          body: values?.emailBody,
        },
      });

      if (val?.data?.sendEmailToMultipleTraders) {
        toast.success(val?.data?.sendEmailToMultipleTraders);
      }
      // if (val?.data?.sendEmailToMultipleTraders?.status === 204) {
      //   toast.error(val?.data?.sendEmailToMultipleTraders?.message);
      // }
      drawerToggle();
    } catch (err) {
      console.error(err);
    }
    resetRowSelection();
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={{
            subject: '',
            emailBody: '',
          }}
          enableReinitialize
          validationSchema={emailValidationSchema}
          onSubmit={handleSubmit}
          children={(props) => {
            return <SendEmailForm {...props} drawerToggle={drawerToggle} />;
          }}
        />
      </ErrorBoundary>
    </div>
  );
};

export default SendEmail;
